import { apiFetch } from "../../lib/utils";

const InternalUserEndpoint = '/InternalUser'
const GetUserName = async () => {
  const res = await apiFetch(`${InternalUserEndpoint}`, "GET");
  if (!res.ok) throw new Error(`Failed to fetch username: ${res.statusText}`);
  return res.json() as Promise<{ username: string }>;
};

export const User ={
    GetUserName
}